import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var BaseBroker = /*#__PURE__*/function () {
  function BaseBroker() {
    _classCallCheck(this, BaseBroker);
    _defineProperty(this, "warned", false);
    // FIXME: Нужно очищать сессию на reconnect,
    //  а еще лучше передать управление над очисткой самим брокерам
    _defineProperty(this, "session", {});
    _defineProperty(this, "handler", void 0);
  }
  _createClass(BaseBroker, [{
    key: "receive",
    value: function receive(obj) {
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var ack = arguments.length > 2 ? arguments[2] : undefined;
      if (!this.handler) throw new Error('Попытка использовать брокер до регистрации handler`а');
      this.handler(obj, _objectSpread(_objectSpread({}, extra), {}, {
        session: this.session
      }), ack);
    }

    /** по умолчанию просто вызываем метод */
  }, {
    key: "onReady",
    value: function onReady(fn) {
      if (!this.warned) {
        this.warned = true;
        console.warn("\x1B[31m\x1B[2monReady is not production ready on ".concat(this.constructor.name, "\x1B[0m"));
      }
      fn();
    }
  }, {
    key: "registerHandler",
    value: function registerHandler(handler) {
      this.handler = handler;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // cleanup
    }
  }]);
  return BaseBroker;
}();